"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmutableERC721MintByID__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "owner_",
                type: "address",
            },
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "string",
                name: "baseURI_",
                type: "string",
            },
            {
                internalType: "string",
                name: "contractURI_",
                type: "string",
            },
            {
                internalType: "address",
                name: "operatorAllowlist_",
                type: "address",
            },
            {
                internalType: "address",
                name: "royaltyReceiver_",
                type: "address",
            },
            {
                internalType: "uint96",
                name: "feeNumerator_",
                type: "uint96",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AllowlistDoesNotImplementIOperatorAllowlist",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "ApproveTargetNotInAllowlist",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ApproverNotInAllowlist",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "CallerNotInAllowlist",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "IImmutableERC721IDAboveThreshold",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "currentOwner",
                type: "address",
            },
        ],
        name: "IImmutableERC721MismatchedTokenOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "IImmutableERC721MismatchedTransferLengths",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "IImmutableERC721NotOwnerOrOperator",
        type: "error",
    },
    {
        inputs: [],
        name: "IImmutableERC721SendingToZerothAddress",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "IImmutableERC721TokenAlreadyBurned",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidShortString",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "PermitExpired",
        type: "error",
    },
    {
        inputs: [],
        name: "SignerCannotBeZerothAddress",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "str",
                type: "string",
            },
        ],
        name: "StringTooLong",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
        ],
        name: "TransferFromNotInAllowlist",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "TransferToNotInAllowlist",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "EIP712DomainChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldRegistry",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newRegistry",
                type: "address",
            },
        ],
        name: "OperatorAllowlistRegistryUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINTER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256[]",
                        name: "tokenIds",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct ImmutableERC721Base.IDBurn[]",
                name: "burns",
                type: "tuple[]",
            },
        ],
        name: "_safeBurnBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIDs",
                type: "uint256[]",
            },
        ],
        name: "burnBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                internalType: "bytes1",
                name: "fields",
                type: "bytes1",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "version",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "verifyingContract",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "extensions",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmins",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "grantMinterRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256[]",
                        name: "tokenIds",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct ImmutableERC721Base.IDMint[]",
                name: "mintRequests",
                type: "tuple[]",
            },
        ],
        name: "mintBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "operatorAllowlist",
        outputs: [
            {
                internalType: "contract IOperatorAllowlist",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "revokeMinterRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "salePrice",
                type: "uint256",
            },
        ],
        name: "royaltyInfo",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256[]",
                        name: "tokenIds",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct ImmutableERC721Base.IDBurn[]",
                name: "burns",
                type: "tuple[]",
            },
        ],
        name: "safeBurnBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
        ],
        name: "safeMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256[]",
                        name: "tokenIds",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct ImmutableERC721Base.IDMint[]",
                name: "mintRequests",
                type: "tuple[]",
            },
        ],
        name: "safeMintBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "from",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "tos",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "tokenIds",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct ImmutableERC721Base.TransferRequest",
                name: "tr",
                type: "tuple",
            },
        ],
        name: "safeTransferFromBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "baseURI_",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_contractURI",
                type: "string",
            },
        ],
        name: "setContractURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint96",
                name: "feeNumerator",
                type: "uint96",
            },
        ],
        name: "setDefaultRoyaltyReceiver",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint96",
                name: "feeNumerator",
                type: "uint96",
            },
        ],
        name: "setNFTRoyaltyReceiver",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint96",
                name: "feeNumerator",
                type: "uint96",
            },
        ],
        name: "setNFTRoyaltyReceiverBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ImmutableERC721MintByID__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(owner_, name_, symbol_, baseURI_, contractURI_, operatorAllowlist_, royaltyReceiver_, feeNumerator_, overrides) {
        return super.deploy(owner_, name_, symbol_, baseURI_, contractURI_, operatorAllowlist_, royaltyReceiver_, feeNumerator_, overrides || {});
    }
    getDeployTransaction(owner_, name_, symbol_, baseURI_, contractURI_, operatorAllowlist_, royaltyReceiver_, feeNumerator_, overrides) {
        return super.getDeployTransaction(owner_, name_, symbol_, baseURI_, contractURI_, operatorAllowlist_, royaltyReceiver_, feeNumerator_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ImmutableERC721MintByID__factory = ImmutableERC721MintByID__factory;
ImmutableERC721MintByID__factory.bytecode = _bytecode;
ImmutableERC721MintByID__factory.abi = _abi;
